<template>
  <v-card flat class="conteneurLead" id="conteneurLead">
    <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
      <v-btn icon @click="cancelDialogEdit()"><v-icon class="white--text">close</v-icon></v-btn>
      <div class="title tf_title_dialog">{{ $t('addIntent') }}</div>
      <v-spacer></v-spacer>
      <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click.native="submitDialogCreateIntent" class="white--text">{{ $t('submit') }}</v-btn>
    </v-card-title>
    
    <v-card-text>
      <v-subheader>{{ $tc('activeIntents', activeIntents, { count: activeIntents }) }} sur 100 maximum</v-subheader>
      <v-text-field
        autofocus
        required
        :label="$t('intentCode')" 
        v-model="newIntentDialog.code"
        counter 
        hint="caractères alphanumériques seulement (A-Z,a-z,0-9), underscores (_) et tirets (-)"
        max="32" >
      </v-text-field>
      <v-textarea 
        :label="$t('description')" 
        v-model="newIntentDialog.desc"
        max="255"
        hint="optionelle mais conseillée"
      ></v-textarea>
      <v-textarea 
        :label="$t('sentence') + '*'" 
        v-model="newIntentDialog.ex"
        max="255"
        required
        hint="Exemple obligatoire"
      ></v-textarea>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click.native="cancelDialogEdit()">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" flat @click.native="submitDialogCreateIntent">{{ $t('submit') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    newIntentDialog: {
      type: Object,
      default: () => ({})
    },
    intents: {
      type: Array,
      default: () => ([])
    },
    examples: {
      type: Array,
      default: () => ([])
    },
    activeIntents: {
      type: Number,
      default: 0
    },
    modeExpert: {
      type: Boolean,
      default: false
    },
    botWorkspace: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      listIntents: [],
      originalIntent: '',
      actualIntent: '-',
      blockSelector: false,
      samples: [],
      changeIntent: ''
    }
  },

  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    cancelDialogEdit () {
      this.$emit('closeDialog')
    },
    submitDialogCreateIntent () {
      console.log('newIntentDialog', this.newIntentDialog)
      if (!this.newIntentDialog.code || this.newIntentDialog.code === '') {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Nom obligatoire', context: 'error' })
        return false
      }
      let newIntentCode = this.intents.find(inte => inte.code === this.newIntentDialog.code)
      console.log('newIntentCode', newIntentCode)
      if (newIntentCode) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Nom déjà utilisé', context: 'error' })
        return false
      }
      const pattern = /^[a-zA-Z0-9_-]+$/g
      if (!pattern.test(this.newIntentDialog.code)) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Format non respecté', context: 'error' })
        return false
      }
      if (!this.newIntentDialog.ex || this.newIntentDialog.ex === '') {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Exemple obligatoire', context: 'error' })
        return false
      }
      let newIntentEx = this.examples.find(sample => sample.ex === this.newIntentDialog.ex)
      if (newIntentEx) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Attention, exemple déjà existant', context: 'error' })
        return false
      }

      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('code', this.newIntentDialog.code)
      dataToPost.append('desc', this.newIntentDialog.desc)
      dataToPost.append('ex', this.newIntentDialog.ex)
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/new_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationSuccess'), context: 'success' })
        this.$emit('newIntendOK', this.newIntentDialog)
        this.cancelDialogEdit()
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' })
      })
    }
  },

  watch: {
    newIntentDialog (val, oldVal) {
      this.originalIntent = ''
      this.actualIntent = '-'
      this.blockSelector = false
      this.samples = []
      this.changeIntent = ''
      this.newIntentDialog.intent ? this.actualIntent = this.newIntentDialog.intent : this.actualIntent = '-'
      this.originalIntent = this.newIntentDialog.intent
      // console.log('this.listIntents', this.listIntents)
      for (let k in this.listIntents) {
        if (this.newIntentDialog.intent === this.listIntents[k].code) {
          console.log('this.changeIntent', this.changeIntent)
          this.changeIntent = this.listIntents[k]
        }
      }
    }
  },

  filters: {
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .btnIntentBot {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzNewIntent.vue